import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMobileSdkTestSeverities } from 'src/apps/mobile-sdk/services/MobileSdkSingleTestService';
import { ISeverityCountType } from 'src/common/components/mobile-scans-impacted-by-severity-chart/MobileScansImpactedBySeverityChart';
import { MOBILE_SDK_TEST_SEVERITIES } from 'src/common/providers/reactQueryProvider/QueryKeys';

interface IUseMobileSdkTestSeveritiesQuery {
	testId: string;
}

export const useMobileSdkTestSeveritiesQuery = ({
	testId
}: IUseMobileSdkTestSeveritiesQuery): UseQueryResult<ISeverityCountType[]> => {
	const severitiesQuery = useQuery(
		[MOBILE_SDK_TEST_SEVERITIES, testId],
		async (): Promise<ISeverityCountType[]> =>
			getMobileSdkTestSeverities({
				testId
			}),
		{
			refetchOnWindowFocus: 'always'
		}
	);

	return severitiesQuery;
};
